/**
 * ==== Bootstrap Plugins ====
 * Bootstrap plugins are auto-invoked
 */
import 'bootstrap';

// import '@popperjs/core';  // Importiert Popper.js 
// import Collapse from 'bootstrap/js/dist/collapse';
import masonry from 'masonry-layout'
import featherlight from 'featherlight';

import '../../../../../../../node_modules/featherlight/release/featherlight.gallery.min';
import '../../../../../../../node_modules/featherlight/release/featherlight.min';

/**
 * ==== Helpers on page load ====
 * - pageInit: Run some general stuff
 * - resetPage: Move footer to the bottom of the page
 */
import {resetPage, pageInit} from "./theme/reset";
// import {addWaveDivsToBody} from "./advanced-admin-script";
import { scrollHeader } from "./theme/scroll";
import {sliderConfiguration} from "./theme/sliders";
import {videoControls} from "./theme/video";
//import {aosFunctions} from "./theme/aos";


pageInit();
resetPage();
// addWaveDivsToBody();
scrollHeader();
sliderConfiguration();
videoControls();
//aosFunctions();


/**
 * Run functions on window-resize
 * - resetPage: Move footer to the bottom of the page
 */
window.addEventListener("resize", function () {
    resetPage();
});